import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EScoreGroupTypes } from 'components/searchAndFilter/constants';
import {
  getScoreIdsForSelectedGroups,
  parseSelectedScoreGroupIds,
} from 'components/commandpanel/ExperimentPanel/DefaultScores/utils';
import { ECanvasPreferencesKeys } from 'enums/ECanvasPreferencesKeys';
import { canvasPreferenceThunk } from 'redux/thunks/common';
import { GetScoreDefn } from 'utils/Global';

export enum ESelectedHitButton {
  None = 0,
  AnyHits = 1,
  AllHits = 2,
}
type HeaderState = {
  scoreGroup: number;
  scoreGroups: number[];
  autoSelectNextWell: boolean;
  hideAutoScores: boolean;
  hitButton: ESelectedHitButton;
  hitScoreGroupType: string;
  hitScoreGroup: number;
  selectedHitScoreGroups: number[] | null;
  uvHitsOnly: boolean;
};

const initialState = {
  hitButton: ESelectedHitButton.None,
  hitScoreGroupType: EScoreGroupTypes.All,
  hitScoreGroup: 0,
  scoreGroups: [],
  selectedHitScoreGroups: null,
  uvHitsOnly: false,
} as HeaderState;

export const headerSlice = createSlice({
  name: 'experiment',
  initialState,
  reducers: {
    setHeaderScoresGroupType: (state, action: PayloadAction<number>): void => {
      state.scoreGroup = action.payload;
    },

    setHeaderScoresGroupTypes: (state, action: PayloadAction<number[]>): void => {
      state.scoreGroups = action.payload;
    },
    setAutoSelectNextWell: (state, action: PayloadAction<boolean>): void => {
      state.autoSelectNextWell = action.payload;
    },
    setHideAutoScores: (state, action: PayloadAction<boolean>): void => {
      state.hideAutoScores = action.payload;
    },
    setHitButton: (state, action: PayloadAction<ESelectedHitButton>) => {
      state.hitButton = action.payload;
    },
    setHitScoreGroupType: (state, action: PayloadAction<string>) => {
      state.hitScoreGroupType = action.payload;
    },
    setHitScoreGroup: (state, action: PayloadAction<number>) => {
      state.hitScoreGroup = action.payload;
    },
    setUvHitsOnly: (state, action: PayloadAction<boolean>) => {
      state.uvHitsOnly = action.payload;
    },
    setSelectedHitScoreGroups: (state, action: PayloadAction<number[]>) => {
      state.selectedHitScoreGroups = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(canvasPreferenceThunk.fulfilled, (state, action) => {
      state.autoSelectNextWell = action.payload[
        ECanvasPreferencesKeys.AutoMoveAfterScoring
      ] as boolean;
      state.scoreGroups = getScoreIdsForSelectedGroups(
        parseSelectedScoreGroupIds(
          action.payload[ECanvasPreferencesKeys.SelectedCanvasScoreGroups] as string,
        ),
        GetScoreDefn() ?? [],
      );
    });
  },
});

export const {
  setHeaderScoresGroupTypes,
  setHeaderScoresGroupType,
  setAutoSelectNextWell,
  setHideAutoScores,
  setHitButton,
  setHitScoreGroupType,
  setHitScoreGroup,
  setUvHitsOnly,
  setSelectedHitScoreGroups,
} = headerSlice.actions;

export default headerSlice.reducer;
